<button mat-icon-button [matMenuTriggerFor]="notificationsMenu" (menuOpened)="getNotifications()" matTooltip="Notifications" class="header-icon-btn">
  <span class="relative inline-flex">
    <mat-icon class="icon-size-7" fontIcon="notifications"></mat-icon>
    @if (unreadNotifications() > 0) {
      <span class="absolute -right-2 -top-2 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[9px] font-bold leading-none text-white ring-2 ring-white">
        {{ unreadNotifications() > 9 ? '9+' : unreadNotifications() }}
      </span>
    }
  </span>
</button>

<mat-menu #notificationsMenu="matMenu" [xPosition]="'before'" class="notifications-panel">
  <div (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between px-4 py-4">
      <div class="flex items-center gap-3">
        <div class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-400">
          <mat-icon class="icon-size-5" fontIcon="notifications"></mat-icon>
        </div>
        <span class="text-base font-bold uppercase tracking-widest text-gray-700">
          Notifications
          @if (unreadNotifications() > 0) {
            <span class="text-primary">({{ unreadNotifications() }})</span>
          }
        </span>
      </div>
      @if (unreadNotifications() > 0) {
        <button class="text-sm font-medium text-primary transition-colors hover:opacity-70" (click)="markAllNotifIsRead($event)">Mark all as read</button>
      }
    </div>

    <mat-divider></mat-divider>
    @if (notificationList.length > 0) {
      <div class="max-h-[420px] overflow-y-auto">
        @for (item of notificationList; track item.id) {
          <div class="relative flex cursor-pointer items-start gap-3 px-4 py-3 transition-all duration-150 hover:bg-gray-50">
            <a class="absolute inset-0" [routerLink]="item.link" [queryParams]="item.linkParams" [attr.aria-label]="item.subject" (click)="openNotification(item, $event)"></a>
            <div class="mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full" [ngClass]="!item.is_read ? 'bg-blue-50 text-blue-400' : 'bg-gray-100 text-gray-400'">
              <mat-icon class="icon-size-5" fontIcon="notifications"></mat-icon>
            </div>

            <div class="min-w-0 flex-1">
              <p class="text-base font-semibold leading-snug" [ngClass]="!item.is_read ? 'text-gray-900' : 'text-gray-600'">
                {{ item.subject }}
              </p>
              <p class="mt-0.5 text-sm text-gray-400">{{ item.created_at | date: 'MMM d, y, h:mm:ss a' }}</p>
            </div>

            <button mat-icon-button class="relative mt-0.5 !h-7 !w-7 flex-shrink-0" [matTooltip]="item.is_read ? 'Mark as unread' : 'Mark as read'" (click)="toggleNotifIsRead(item, $event)">
              <mat-icon class="icon-size-5" [ngClass]="!item.is_read ? 'text-blue-400' : 'text-gray-400'" [fontIcon]="!item.is_read ? 'mail' : 'drafts'"></mat-icon>
            </button>
          </div>

          <mat-divider></mat-divider>
        }
      </div>

      <div class="flex items-center justify-center bg-gray-50 py-3">
        <a routerLink="/notifications" class="text-base font-semibold text-primary transition-colors hover:text-primary-700"> See All </a>
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center px-6 py-10 text-center">
        <mat-icon class="mb-3 text-gray-200 icon-size-12" fontIcon="notifications_off"></mat-icon>
        <p class="text-base font-medium text-gray-500">You're all caught up!</p>
        <p class="text-sm text-gray-400">No new notifications</p>
      </div>
    }
  </div>
</mat-menu>
